import React from 'react';
import { connect } from 'react-redux';
// LevelEditor imports
import ItemSelectorContainer from './Container';
import BtnExpand from './btnExpand';

class ItemSelector extends React.Component {
    isActive = () => {        
        const { levelEditor } = this.props;
        return levelEditor.itemSelectorOpen;
    }

    render = () => {
        return (
            <div 
                id="level-editor-item-selector" 
            >
                <ItemSelectorContainer />
                <BtnExpand />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps
)(ItemSelector);